export enum AppDomain {
  LENDI_PL = 'lendi.pl',
  NESTO_RO = 'imobiliare.ro',
}
